module.exports = __webpack_public_path__ + "img/img_guide_1.018f2a30.png";